import React from 'react'

import { Grid, Theme, Skeleton, Box, Stack } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { ActionCall, ScreenEnum, ViewEnum } from '@professocial/professocialTypes/types/commonTypes'
import { InstagramPage, InstagramPost } from '@3m5/sm_publish-frontend-api'

import ProfileImage from '../../../../shared/components/ModuleComponents/Post/modules/ProfileImage'
import LinkHeadline from '../../../../shared/components/ModuleComponents/Post/modules/LinkHeadline'
import SubHeadline from '../../../../shared/components/ModuleComponents/Post/modules/SubHeadline'
import Text from '../../../../shared/components/ModuleComponents/Post/modules/Text'
import Comments from '../../../../shared/components/ModuleComponents/Post/modules/Comments/Comments'
import { getDuration } from '../../../../util/getDuration'
import { useSelector } from 'react-redux'
import { getInstagramPage } from '../../../../store/instagram/instagram.selector'
import { NetworkType } from '@3m5/sm_publish-frontend-api'
import { PostingRootState } from '../../../../store/postingRoot.reducer'
import { namedRequestData } from '../../../../store/common/common.selectors'
import { getIgPageFeedInitiated } from '../../../../store/instagram/instagram.actions'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
}))

interface IPostProps {
  view?: ViewEnum
  size?: ScreenEnum
  networkPageId?: string
  post: InstagramPost
  networkType?: NetworkType
  deleteComment?: (value: any) => void
}

const InstagramOverviewPost: React.FC<IPostProps> = (props: IPostProps) => {
  const classes = useStyles()

  const view = props.view || ViewEnum.overview
  const size = props.size || ScreenEnum.xl

  const networkType: NetworkType = props.networkType || NetworkType.Facebook
  const storedInstagramPage: InstagramPage | undefined = useSelector(getInstagramPage)

  const statusOnFeedLoad: ActionCall | undefined = useSelector((state: PostingRootState) => namedRequestData(state, getIgPageFeedInitiated.type))

  return (
    <div className={classes.paper}>
      <Grid container>
        <Grid item xs='auto'>
          <ProfileImage
            data={`https://www.instagram.com/${props.post.postedByNetworkName}/?__a=1`}
            view={props.view}
          />
        </Grid>
        <Grid item xs={8} container>
          <Grid item xs={12}>
            <LinkHeadline
              post={props.post}
              networkType={networkType}
              value={{
                url: `https://www.instagram.com/${storedInstagramPage?.pageName}`,
                label: storedInstagramPage?.pageName,
              }}
              view={view}
              size={size}
            />
            <Text
              post={props.post}
              networkType={networkType}
              value={props.post.content[0].text}
              view={view}
              size={size}
            />
          </Grid>
          <Grid item xs={12}>
            <SubHeadline
              post={props.post}
              networkType={networkType}
              value={props.post.postedAt && getDuration(props.post.postedAt.getTime())}
              view={view}
              size={size}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          {statusOnFeedLoad?.status === 'pending' && statusOnFeedLoad?.id === props.post.networkPostId && (
            <Grid container item xs={12} sx={{ pt: 2 }}>
              <Grid container>
                <Grid item xs='auto'>
                  <Skeleton sx={{ mr: '13px' }} variant='circular' width={40} height={40} />
                </Grid>
                <Grid xs container item>
                  <Stack direction='row' alignItems='center' width='100%'>
                    <Skeleton width='100%' height={40} variant='rectangular' />
                    <Box marginLeft='auto' width='50px' />
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          )}
          <Comments
            networkPageId={props.networkPageId}
            post={props.post}
            networkType={networkType}
            value={props.post}
            onChange={props.deleteComment && props.deleteComment}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default InstagramOverviewPost
